module.exports = __webpack_public_path__ + "img/3-oneImg.6a2326df.png";